export enum StoresScope {
	Stores = 'stores',
	Reports = 'reports',
}
